import { Card } from "react-bootstrap"

const MeetingCard = ({meeting, date, content, col}) => {
    return (
    <Card style={{marginBottom: '1em'}} bg={col} text="white">
        <Card.Header>{meeting}</Card.Header>
        <Card.Body>
            <Card.Text>{content}</Card.Text>
        </Card.Body>
        <Card.Footer>{date}</Card.Footer>
    </Card>)
}
export default MeetingCard